import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['banner'];

  close() {
    this.bannerTarget.remove();
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 30);
    document.cookie = `promotion_banner_closed=true; expires=${expirationDate.toUTCString()};`;
  }
}
